/* ATLAS: lazy Growave card hearts (2026-09).
   snippets/product-card.liquid renders <span class="atlas-wl-lazy" data-atlas-pid data-atlas-vid hidden> per card
   instead of the Growave placeholder. This script swaps the marker for the real placeholder
   <div class="gw-add-to-wishlist-product-card-placeholder atlas-card-wishlist" ...> once the card is within 400px of
   the viewport. Growave's injector mounts a widget on every placeholder present at load OR inserted later (it does not
   react to class changes on existing nodes), so inserting the real node late is what makes the mount lazy.
   Cards that arrive later (infinite-scroll append, filter morph, quick-add / search results) are picked up by a
   document-level MutationObserver. Idempotent: a marker is swapped at most once and then leaves the DOM; loading this
   file twice is a no-op. Without JS or on old browsers there is simply no card heart; the card itself is untouched. */
(function () {
  'use strict';
  if (window.__atlasWishlistLazy) return;
  window.__atlasWishlistLazy = true;
  if (!('IntersectionObserver' in window) || !('MutationObserver' in window) || !('WeakMap' in window)) return;

  var MARKER = 'span.atlas-wl-lazy';
  var markerByTarget = new WeakMap();

  function mount(marker) {
    if (!marker || !marker.isConnected || marker.getAttribute('data-atlas-wl') === 'done') return;
    marker.setAttribute('data-atlas-wl', 'done');
    var pid = marker.getAttribute('data-atlas-pid');
    var vid = marker.getAttribute('data-atlas-vid');
    if (!pid) { marker.remove(); return; }
    var host = document.createElement('div');
    host.className = 'gw-add-to-wishlist-product-card-placeholder atlas-card-wishlist';
    host.setAttribute('data-gw-product-id', pid);
    if (vid) host.setAttribute('data-gw-variant-id', vid);
    host.setAttribute('data-gw-wishlist-counter-position', 'right-top');
    host.style.display = 'block';
    marker.replaceWith(host);
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      var target = entries[i].target;
      io.unobserve(target);
      var marker = markerByTarget.get(target);
      markerByTarget.delete(target);
      mount(marker);
    }
  }, { rootMargin: '400px 0px 400px 0px' });

  /* The marker is hidden (no layout box, so it never intersects); its card is observed instead. */
  function track(marker) {
    if (marker.getAttribute('data-atlas-wl')) return;
    marker.setAttribute('data-atlas-wl', 'watch');
    var target = marker.closest('product-card') || marker.parentElement;
    if (!target) return;
    markerByTarget.set(target, marker);
    io.observe(target);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches(MARKER)) { track(root); return; }
    var list = root.querySelectorAll(MARKER);
    for (var i = 0; i < list.length; i++) track(list[i]);
  }

  function start() {
    scan(document.body);
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var i = 0; i < added.length; i++) scan(added[i]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
    else window.setTimeout(start, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
